import { render, staticRenderFns } from "./UnitAndRoleLink.vue?vue&type=template&id=c94a3890&scoped=true"
import script from "./UnitAndRoleLink.vue?vue&type=script&lang=js"
export * from "./UnitAndRoleLink.vue?vue&type=script&lang=js"
import style0 from "./UnitAndRoleLink.vue?vue&type=style&index=0&id=c94a3890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94a3890",
  null
  
)

export default component.exports